module.exports = __webpack_public_path__ + "media/images/sp/top/recommend_plan_photowedding-807b577f530056066de918312c2589de.webp";